import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/products/:productId/prices`;
const pathById = `${pathBase}/:priceId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const prices = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  delete: apiPathFunc(pathById),
};
